import { SearchParams } from '../SearchParams';

const toExtraPaymentLink = (url: string, accountId: string, kidNumber: string) => {
    const searchParams = new URLSearchParams({
        [SearchParams.lokalbank.KID]: kidNumber,
        [SearchParams.lokalbank.RECEIVER]: accountId,
        [SearchParams.lokalbank.RETURN_URL]: `${window.location.href}&invalidate=true`,
    }).toString();

    return `${url}?${searchParams}`;
};

export const Navigate = {
    toExtraPaymentLink,
};
